<!--
 * @Author: your name
 * @Date: 2022-03-10 13:24:49
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-16 14:09:54
 * @Description: file content
-->
<template>
  <div class="lottery-table">
    <Top></Top>
    <Bottom></Bottom>
  </div>
</template>

<script>
  import Bottom from "./components/Bottom";
  import Top from "./components/Top";
  export default {
    components: {
      Bottom,
      Top,
    },
  };
</script>

<style lang="less" scoped>
  @import "../var";
  // ---------------------------------

  .lottery-table {
    min-width: 376px;
    min-height: 667px;
    width: 100%;
    height: 100%;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    box-sizing: border-box;
    background: url("~@/assets/lottery/bg.jpg") no-repeat;
    background-size: 100% 100%;

    background-color: #ffffff;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #333;
    padding: 0;
    margin: auto 0;

    .bottom {
      position: relative;
      z-index: 99;
      width: 100%;
      background-color: #ffffff;
      min-height: 440px;
      border-radius: 54px 54px 0 0;
      justify-content: space-evenly;
      top: -@top-bar-height*2;
    }
  }
</style>
